import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getBrandDetails } from "../../api/brandStore";

export const initialState = {
  brandDetailsData: null,
  brandDetailsLoading: false,
  brandDetailsError: null,
};

export const getBrandDetailsData = createAsyncThunk(
  "brandDetails/get-data",
  async (id, {rejectWithValue}) => {
    try {
      const response = await getBrandDetails(id);

      return response.data;
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || "Error");
    }
  },
);

export const brandDetailsSlice = createSlice({
    name: "brandDetails",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
      builder
        .addCase(getBrandDetailsData.pending, (state) => {
          state.brandDetailsLoading = true;
          state.brandDetailsError = null;
        })
        .addCase(getBrandDetailsData.fulfilled, (state, action) => {
          state.brandDetailsLoading = false;
          state.brandDetailsData = action.payload;
        })
        .addCase(getBrandDetailsData.rejected, (state, action) => {
          state.brandDetailsLoading = false;
          state.brandDetailsError = action.payload;
        })
    },
  })
;

export default brandDetailsSlice.reducer;
